import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { WebcamModule } from 'ngx-webcam';
import { MenubarModule } from 'primeng/menubar';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { PasswordModule } from 'primeng/password';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CameraComponent } from './components/camera/camera.component';
import { CandidateFormComponent } from './components/candidate-form/candidate-form.component';
import { ConfirmSubmitComponent } from './components/confirm-submit/confirm-submit.component';
import { TestNavbarComponent } from './components/test-navbar/test-navbar.component';
import { AssessmentPageComponent } from './components/assessment-page/assessment-page.component';
import { QuestionNumberComponent } from './components/question-number/question-number.component';
import { QuestionPageComponent } from './components/question-page/question-page.component';
import { LoaderComponent } from './components/loader/loader.component';
import { VerifyComponent } from './components/verify/verify.component';
import { InstructionComponent } from './components/instruction/instruction.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthInterceptorService } from './intercepters/auth.intercepter';
import { CandidateDetailComponent } from './components/candidate-detail/candidate-detail.component';
import { WarningComponent } from './components/warning/warning.component';

@NgModule({
  declarations: [
    AppComponent,
    CameraComponent,
    CandidateFormComponent,
    ConfirmSubmitComponent,
    TestNavbarComponent,
    AssessmentPageComponent,
    QuestionNumberComponent,
    QuestionPageComponent,
    LoaderComponent,
    VerifyComponent,
    InstructionComponent,
    CandidateDetailComponent,
    WarningComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    WebcamModule,
    MenubarModule,
    ButtonModule,
    RippleModule,
    DialogModule,
    ToastModule,
    ConfirmDialogModule,
    HttpClientModule,
    DialogModule,
    CheckboxModule,
    InputTextModule,
    FloatLabelModule,
    PasswordModule
  ],
  providers: [
    MessageService,
    ConfirmationService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
